import { Component, ViewChild, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit, ChangeDetectorRef, SimpleChanges, TemplateRef, ElementRef, Inject } from '@angular/core';
import { LoaderService } from '../../shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { Observable, Subscription } from 'rxjs';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';

@Component({
  selector: 'app-addurlForBroadCast',
  templateUrl: './addurlForBroadCast.component.html',
  styleUrls: ['./addurlForBroadCast.component.scss'] 
})

export class AddurlForBroadCastComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;   
  formfoldername:string="";
  disabledUpdate:boolean=true;
  spinner:boolean=false;
  successUrl:string="";
  declineUrl:string="";
  formFolderID:number=0;
  OfficeIDList: any = [];
  myOfficeID: any;
  title:string="";

  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<AddurlForBroadCastComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private statusConst: StatusConstant,
    private formService: FormsService,private toastr: ToastrService,private statusConstant: StatusConstant) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach((oe:any) => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }  
  
  ngOnInit(): void {
    if(this.data.type==1){
      this.title="Add URL";
    }
    if(this.data.type==2){
      this.title="Add Video URL";
    }     
  }     
    

  addUpdateFolderUrl() {
    this.data;     
    if(this.successUrl==null){
      this.successUrl="";
    }    
    if(this.showSuccessUrlMessage==true){
      return;
    }     
    if(this.successUrl==""){ 
      this.toastr.warning('Please add Url.', '', {
        timeOut: 3000,
      });   
      return;    
    } else{

      if(this.data.type==1){
       this.dialogRef.close({
        attachType:0, //0 url,1 File, 2 Video
        url: this.successUrl,
        type: 'Any URL'
      });
      }
      if(this.data.type==2){
       this.dialogRef.close({
        attachType:2, //0 url,1 File, 2 Video
        url: this.successUrl,
        type: 'Video URL'
      });
      }
      
    }  
  }
 

 close() {
  //this.formDialog.reset();
  //this.dialog.closeAll();
   this.dialogRef.close();
 }

 showSuccessUrlMessage:boolean=false;
 showDeclineUrlMessage:boolean=false;

 onSuccessURLChange(searchValue: string): void {  
  if(searchValue==""){
    this.showSuccessUrlMessage=false;
  }
  if(searchValue!=""){
   var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
   if(!regex.test(searchValue)) {
    this.showSuccessUrlMessage=true;
   }else{
    this.showSuccessUrlMessage=false;
   }
  }
}


  
}
